import { z } from "zod";
/**
 * Admin-authored notification surfaced to every signed-in user as a modal on
 * their next app load. Stored at `/announcements/{announcementId}`. Each user
 * records their dismissal in `/users/{uid}/seenAnnouncements/{announcementId}`
 * so the modal only appears once per (user, announcement) pair.
 */
export const AnnouncementSchema = z.object({
    title: z.string().min(1).max(120),
    body: z.string().min(1).max(2000),
    active: z.boolean(),
    createdAt: z.unknown().optional(),
    updatedAt: z.unknown().optional(),
    createdBy: z.string().nullable().optional(),
});
export const AnnouncementWithIdSchema = AnnouncementSchema.extend({
    id: z.string(),
});
